import { LearningResourceFeeDto } from "./learningresourcefeedto";
import { VatPatternDto } from "./vatPattern/vatpatterndto";

export class LearningResourceFeePriceDto {
    idOwnLearningResourcePriceDetail?: number;
    startDate?: string;
    endDate?: string;
    firstTermPayment?: boolean;
    price?: number;
    ownLearningResourceRateDto?: LearningResourceFeeDto;
    vatPatternDto?: VatPatternDto; // Cambia el tipo según tu definición de VatPatternDto

    constructor(data?: Partial<LearningResourceFeePriceDto>) {
        Object.assign(this, data);
    }
}
